import { render, staticRenderFns } from "./ReportSaved.vue?vue&type=template&id=9630dd28"
import script from "./ReportSaved.vue?vue&type=script&lang=js"
export * from "./ReportSaved.vue?vue&type=script&lang=js"
import style0 from "./ReportSaved.vue?vue&type=style&index=0&id=9630dd28&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports